import { useEffect, useMemo } from 'react';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import { useSelector } from 'react-redux';
import './style.css';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Billboard from '../../../components/Billboard';
import Page from '../../../components/Page';

const Page404 = () => {

    const labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale );

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <Page modifier="404" title={ labels.title }>
            <Billboard alignItems="center" title={ labels.title } body={ labels.body } Icon={ VisibilityIcon } />
        </Page>
    )

}

export default Page404;